import { Spin } from 'antd';
import { BtlBaseForm } from 'pages/BtlApplicationFormPage/BtlBaseForm';
import { useOoCaseExpensesForm } from './useOoCaseExpensesForm';

interface CaseExpensesPageProps {
  caseId: string;
  isCaseLoading: boolean;
}

export function CaseExpensesPage({ caseId, isCaseLoading }: CaseExpensesPageProps) {
  const form = useOoCaseExpensesForm({ caseId, isCaseLoading });

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return <BtlBaseForm {...form.formProps} />;
}
